import { injectGlobal } from "styled-components"
import { above, below } from "../style/functions";

injectGlobal`
	.text-center-above-tablet {
      ${above.tablet`
		text-align:center;
	  `}; 		
	}

	.hide-below-tablet {
      ${below.tablet`
          display:none !important;
	  `}; 
	}
`


// WEBPACK FOOTER //
// ./src/style/util.js